// extracted by mini-css-extract-plugin
module.exports = {"root":"how-it-works_root__Feh2X","title":"how-it-works_title__eR8hL","cardList":"how-it-works_cardList__7K4om"};